import { useEffect, useState } from "react";
import { Ikon, Iskelet, KonuDurumDagilimi, cn } from "@koclukpanel/ui";
import { kendiKaydim, konuIlerlemem } from "./api";
import { hataMetni } from "./hata-metni";
import {
  DURUM_ADI,
  derslereGore,
  tamamlandiMi,
  tekrarGerekiyorMu,
  type DersGrubu,
} from "./konu-durumu";

/**
 * KONULARIM — F-TPC-01b (04.10.2026, müşteri revizesi)
 *
 * Tamamlanan konular tikli, liste SALT OKUNUR: işaretlemeyi eğitim koçu
 * yapıyor. Ekranda hiçbir düğme yok — olsaydı sunucu zaten reddederdi,
 * ama öğrenci bunu ancak tıklayınca öğrenirdi.
 *
 * Dersler başta KAPALI değil açık: öğrencinin ilk sorusu "hangi
 * konular bitti" ve cevabı bir dokunuş arkasına saklamak gereksiz.
 */
export function Konularim() {
  const [gruplar, setGruplar] = useState<DersGrubu[] | null>(null);
  const [hata, setHata] = useState<string | null>(null);

  useEffect(() => {
    let iptal = false;
    void (async () => {
      try {
        const ben = await kendiKaydim();
        const satirlar = await konuIlerlemem(ben.id);
        if (!iptal) setGruplar(derslereGore(satirlar));
      } catch (e) {
        if (!iptal) setHata(hataMetni(e, "Konu listesi alınamadı."));
      }
    })();
    return () => {
      iptal = true;
    };
  }, []);

  if (hata) {
    return (
      <p role="alert" className="rounded-alan bg-hata-50 text-hata-700 px-3 py-2 text-sm">
        {hata}
      </p>
    );
  }
  if (gruplar === null) return <Iskelet satir={5} />;
  if (gruplar.length === 0) {
    return (
      <p className="text-notr-600 text-sm">
        Konu listen henüz hazırlanmadı. Eğitim koçun müfredatını eklediğinde burada görünecek.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <p className="text-notr-600 text-xs">
        Konuları eğitim koçun işaretler. Bir konuyu bitirdiğini düşünüyorsan koçuna söyle.
      </p>
      {/* Dalga 3 — bütün dersler; arşivli konular sayılmıyor (bileşen kapsamı yazıyor). */}
      <KonuDurumDagilimi
        konular={gruplar.flatMap((g) => g.konular)}
        etiketler={DURUM_ADI}
        kapsamMetni="Bütün dersler"
        baslik="Konularının durumu"
      />
      {gruplar.map((g) => (
        <section
          key={g.lessonId}
          aria-labelledby={`ders-${g.lessonId}`}
          className="rounded-kart border-notr-200 bg-notr-0 shadow-kart border p-3"
        >
          <div className="mb-2 flex items-baseline justify-between gap-2">
            <h3 id={`ders-${g.lessonId}`} className="text-notr-900 text-sm font-semibold">
              {g.ders}
            </h3>
            <span className="text-notr-600 shrink-0 text-xs tabular-nums">
              {g.tamamlanan} / {g.toplam} tamamlandı
            </span>
          </div>
          {/* Çubuk dekor değil: yüzdeyi metin zaten söylüyor, çubuk ekran okuyucudan gizli. */}
          <div aria-hidden="true" className="bg-notr-100 mb-3 h-1.5 overflow-hidden rounded-full">
            <div
              className="bg-basarili-500 h-full rounded-full"
              style={{ width: g.toplam === 0 ? 0 : `${(g.tamamlanan / g.toplam) * 100}%` }}
            />
          </div>
          <ul className="flex flex-col">
            {g.konular.map((k) => {
              const bitti = tamamlandiMi(k.stage);
              const tekrar = tekrarGerekiyorMu(k.stage);
              return (
                <li
                  key={k.topicId}
                  className="border-notr-100 flex min-h-10 items-center gap-2.5 border-t py-1.5 first:border-t-0"
                >
                  <span
                    aria-hidden="true"
                    className={cn(
                      "grid size-5 shrink-0 place-items-center rounded-full border",
                      bitti ? "border-basarili-500 bg-basarili-500 text-notr-0" : "border-notr-300",
                    )}
                  >
                    {bitti && <Ikon ad="tamam" className="size-3.5" />}
                  </span>
                  <span
                    className={cn(
                      "min-w-0 flex-1 text-sm",
                      bitti ? "text-notr-900" : "text-notr-700",
                    )}
                  >
                    {k.ad}
                    {k.arsivli && <span className="text-notr-600"> (müfredattan çıkarıldı)</span>}
                  </span>
                  <span
                    className={cn(
                      "shrink-0 text-xs",
                      bitti
                        ? "text-onay-700 font-medium"
                        : tekrar
                          ? "text-uyari-800 font-medium"
                          : "text-notr-600",
                    )}
                  >
                    {DURUM_ADI[k.stage]}
                  </span>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </div>
  );
}
